import { render } from "./UrlElement.vue.js?vue&type=template&id=64d89510!=!../../../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./UrlElement.vue?vue&type=template&id=64d89510"
import script from "./UrlElement.vue.js?vue&type=script&lang=js!=!../../../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./UrlElement.vue?vue&type=script&lang=js"
export * from "./UrlElement.vue.js?vue&type=script&lang=js!=!../../../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./UrlElement.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-components/render-engine/components/production/elements/url-element/UrlElement.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "64d89510"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('64d89510', __exports__)) {
    api.reload('64d89510', __exports__)
  }
  
  module.hot.accept("./UrlElement.vue.js?vue&type=template&id=64d89510!=!../../../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./UrlElement.vue?vue&type=template&id=64d89510", () => {
    api.rerender('64d89510', render)
  })

}


export default __exports__